import { FolderPlus, Loader, Pencil } from "lucide-react";
import { TimeoffCategoryType } from "../../../../types";
import { useNavigate } from "react-router";
import * as Icons from "lucide-react";

interface CategoriesInterface {
    setSelectedCategory: (category: TimeoffCategoryType) => void;
    selectedCategory: TimeoffCategoryType | null;
    categories: TimeoffCategoryType[];
    isLoadingCategories: boolean;
    handleAddCategory: () => void;
    handleUpdateCategory: (category: TimeoffCategoryType) => void;
}

const CategoriesSidebar: React.FC<CategoriesInterface> = ({
    categories,
    setSelectedCategory,
    selectedCategory,
    isLoadingCategories,
    handleAddCategory,
    handleUpdateCategory,
}) => {
    const isSelected = (category?: TimeoffCategoryType) => {
        if (category === undefined) {
            return false;
        }
        return category.category_code == selectedCategory?.category_code;
    };
    const getIconComponent = (iconName?: string) => {
        if (!iconName) return null;
      
        // Convert kebab-case or lowercase to PascalCase
        const pascalCase = iconName
          .split(/[-_]/g)
          .map(part => part.charAt(0).toUpperCase() + part.slice(1))
          .join("");
      
        const Icon = Icons[pascalCase as keyof typeof Icons];
        return Icon as React.FC<React.SVGProps<SVGSVGElement>> | null;
      };
    return (
        <div className="w-64 bg-white h-screen p-4 border-r border-gray-300">
            <ul>
                <li
                    className="flex items-center p-3 rounded-lg cursor-pointer text-gray-700 border border-gray-300 mb-2"
                    onClick={handleAddCategory}
                >
                    <FolderPlus className="mr-2" /> Add Category
                </li>
                {isLoadingCategories ? (
                    <div className="flex items-center justify-center h-full min-h-[300px]">
                        <Loader size={25} className="animate-spin text-gray-500" />
                    </div>
                ) : (
                    <div className="mt-4 max-h-full overflow-y-auto">
                        {categories?.map((item, index) => {
                            const IconComponent = getIconComponent(item.icon);


                            return (
                                <li
                                    key={index}
                                    className={`flex items-center justify-between p-3 rounded-lg cursor-pointer text-gray-700 ${
                                        isSelected(item) ? "bg-blue-100 border border-blue-300" : ""
                                    }`}
                                    onClick={() => setSelectedCategory(item)}
                                >
                                    <div className="flex items-center">
                                        {IconComponent && <IconComponent className="w-5 h-5 mr-2 text-gray-700" />}
                                        {item.category_name}
                                    </div>

                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUpdateCategory(item);
                                        }}
                                        className="text-gray-500 hover:text-gray-700 transition duration-150 ease-in-out"
                                    >
                                        <Pencil className="w-5 h-5" />
                                    </button>
                                </li>
                            );
                        })}
                    </div>
                )}
            </ul>
        </div>
    );
};

export default CategoriesSidebar;
